import RfiEntityCellItem from './RfiEntityMenuItem';

export default RfiEntityCellItem;
